import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_RFIS_REFRESH: createSagaAction('JOB_SITE_RFIS_REFRESH'),

  JOB_SITE_RFI_CREATE: createSagaAction('JOB_SITE_RFI_CREATE'),
  JOB_SITE_RFI_UPDATE: createSagaAction('JOB_SITE_RFI_UPDATE'),
  JOB_SITE_RFI_DELETE: createSagaAction('JOB_SITE_RFI_DELETE'),

  GET_RFI_DATA: createSagaAction('GET_RFI_DATA'),

  UPLOAD_RFI_ATTACHMENT: createSagaAction('UPLOAD_RFI_ATTACHMENT'),
  GET_RFI_ATTACHMENTS: createSagaAction('GET_RFI_ATTACHMENTS'),
  UPDATE_RFI_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_RFI_ATTACHMENT_DESCRIPTION'),
  DELETE_RFI_ATTACHMENT: createSagaAction('DELETE_RFI_ATTACHMENT')
}

// Action Creators
export const actions = {
  jobSiteRFIsRefresh: ({ jobId, next }) => ({
    type: constants.JOB_SITE_RFIS_REFRESH.ACTION,
    jobId,
    next
  }),

  createRFI: ({ jobId, content, rfiItems, userId }) => ({
    type: constants.JOB_SITE_RFI_CREATE.ACTION,
    jobId,
    content,
    rfiItems,
    userId
  }),

  updateRFI: ({ jobId, rfiId, content, rfiItems, userId }) => ({
    type: constants.JOB_SITE_RFI_UPDATE.ACTION,
    jobId,
    rfiId,
    content,
    rfiItems,
    userId
  }),

  deleteRFI: ({ rfiId, jobId }) => ({
    type: constants.JOB_SITE_RFI_DELETE.ACTION,
    jobId,
    rfiId
  }),

  getRfiData: ({ rfiId, jobId }) => ({
    type: constants.GET_RFI_DATA.ACTION,
    jobId,
    rfiId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, rfiId }) => ({
    type: constants.UPLOAD_RFI_ATTACHMENT.ACTION,
    formData,
    rfiId
  }),

  getAttachments: ({ rfiId }) => ({
    type: constants.GET_RFI_ATTACHMENTS.ACTION,
    rfiId
  }),

  updateAttachmentDescription: ({ attachmentId, rfiId, description, userId }) => ({
    type: constants.UPDATE_RFI_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    rfiId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, rfiId }) => ({
    type: constants.DELETE_RFI_ATTACHMENT.ACTION,
    attachmentId,
    rfiId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_RFIS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_RFIS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteRFIs: action.payload
      }
    case constants.JOB_SITE_RFIS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_RFI_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_RFI_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_RFI_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_RFI_DATA.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_RFI_DATA.SUCCESS:
      return {
        ...state,
        rfiItems: action.payload
      }

    case constants.UPLOAD_RFI_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_RFI_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_RFI_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_RFI_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobSiteRFIAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_RFI_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_RFI_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_RFI_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteRFIActions.js